import api from "@/lib/axios";


const getErrors = (errors) => {
    const te = [];
    Object.keys(errors).forEach(key => te.push(errors[key][0]));
    return te;
}


export const stageService = {

    // get stages for a specific vacancy
    getVacancyStages: async (vacancyId) => {
        try {
            const response = await api.get(`/vacancy/${vacancyId}/statuses`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to get vacancy stages: " + error.message);
        }
    },
}

